import React from 'react';
import ReactDOM from 'react-dom';
import Root from './origin/Root';
import reportWebVitals from './reportWebVitals';
import { LoginService, Topics } from '@inas/common';
import { Publish } from './core/PubSub';
import { PAGE_KEY } from './constants/config';

// Fix for Levity - Callback for AWSLogin
LoginService.init( () => {
  Publish(Topics.IS_LOGIN, { isLogin: true });
  LoginService.loginRedirect(PAGE_KEY);
});

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
